<div class="ajax-loading ajax-popup-loading"><div class="loading-icon"></div></div>
<div class="mat-dialog-title" mat-dialog-title="">
    <h2>Add Configuration</h2>
    <button mat-button mat-dialog-close class="close"></button>
</div>
<div class="model-dailog-body">
    <form (ngSubmit)="saveConfiguration()">
        <div mat-dialog-content class="example-container">
            <div class="row m-t-10">
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-select [formControl]="groupId" placeholder="Group"
                                    name="group" [(ngModel)]="configurationModel.groupId">
                            <mat-option value="">Select Group</mat-option>
                            <mat-option *ngFor="let group of configurationGroupList" [value]="group.groupId">{{group.groupName}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="groupId.invalid">Group is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <mat-select [formControl]="configurationTypeCode" placeholder="Type" (selectionChange)="onTypeChange()"
                                    name="configurationTypeCode" [(ngModel)]="configurationModel.configurationTypeCode">
                            <mat-option value="">Select Type</mat-option>
                            <mat-option *ngFor="let type of configurationTypeList" [value]="type.code">{{type.description}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="configurationTypeCode.invalid">Type is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Key"
                                [formControl]="configKey" name="configKey" [(ngModel)]="configurationModel.configKey" />
                        <mat-error *ngIf="configKey.invalid">Key is required</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6">
                    <mat-form-field>
                        <input matInput type="text" maxlength="100" placeholder="Name" name="name" [(ngModel)]="configurationModel.name" />
                    </mat-form-field>
                </div>
                <div class="col-md-12">
                    <mat-form-field>
                        <textarea matInput maxlength="2000" placeholder="Description" name="description" [(ngModel)]="configurationModel.description"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row m-t-10" *ngIf="configurationModel.configurationTypeCode === singleConfigurationTypeCode">
                <div class="col-md-12">
                    <mat-form-field>
                        <textarea matInput maxlength="1000" placeholder="Value" name="value" [(ngModel)]="configurationModel.value"></textarea>
                    </mat-form-field>
                </div>
            </div>
            <div class="row m-t-10" *ngIf="configurationModel.configurationTypeCode === matrixConfigurationTypeCode">
                <div class="col-md-4 m-t-15 align-self-center">
                    <span class="form-label">Condition 1 </span><span class="required">*</span>
                </div>
                <div class="col-md-8">
                    <mat-form-field>
                        <mat-select (selectionChange)="onConditionChange()" [formControl]="condition1" placeholder="Condition 1"
                                    name="condition1" [(ngModel)]="configurationModel.addConfigurationMatrixModel.condition1">
                            <mat-option value=''>Select</mat-option>
                            <mat-option *ngFor="let configuration of configurationByTypesList" [value]="configuration.configurationId">{{configuration.configKey}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="condition1.invalid">Condition 1 is required</mat-error>
                    </mat-form-field>
                </div>
            </div>
            <div class="row m-t-10" *ngIf="configurationModel.configurationTypeCode == matrixConfigurationTypeCode">
                <div class="col-md-4 m-t-15 align-self-center">
                    <span class="form-label">Condition 2(Optional)</span>
                </div>
                <div class="col-md-8">
                    <mat-form-field>
                        <mat-select (selectionChange)="onConditionChange()" placeholder="Condition 2"
                                    [disabled]="configurationModel.addConfigurationMatrixModel.condition1 == null || configurationModel.addConfigurationMatrixModel.condition1.length <= 0"
                                    name="condition2" [(ngModel)]="configurationModel.addConfigurationMatrixModel.condition2">
                            <mat-option value=''>Select</mat-option>
                            <mat-option *ngFor="let configuration of configurationByTypesList" [value]="configuration.configurationId">{{configuration.configKey}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row m-t-10" *ngIf="configurationModel.configurationTypeCode == matrixConfigurationTypeCode">
                <div class="col-md-4 m-t-15 align-self-center">
                    <span class="form-label">Condition 3(Optional)</span>
                </div>
                <div class="col-md-8">
                    <mat-form-field>
                        <mat-select (selectionChange)="onConditionChange()" placeholder="Condition 3"
                                    [disabled]="configurationModel.addConfigurationMatrixModel.condition2 == null || configurationModel.addConfigurationMatrixModel.condition2.length <= 0"
                                    name="condition3" [(ngModel)]="configurationModel.addConfigurationMatrixModel.condition3">
                            <mat-option value=''>Select</mat-option>
                            <mat-option *ngFor="let configuration of configurationByTypesList" [value]="configuration.configurationId">{{configuration.configKey}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row m-t-10" *ngIf="configurationModel.configurationTypeCode == matrixConfigurationTypeCode">
                <div class="col-md-4 m-t-15 align-self-center">
                    <span class="form-label">Condition 4(Optional)</span>
                </div>
                <div class="col-md-8">
                    <mat-form-field>
                        <mat-select (selectionChange)="onConditionChange()" placeholder="Condition 4"
                                    [disabled]="configurationModel.addConfigurationMatrixModel.condition3 == null || configurationModel.addConfigurationMatrixModel.condition3.length <= 0"
                                    name="condition4" [(ngModel)]="configurationModel.addConfigurationMatrixModel.condition4">
                            <mat-option value=''>Select</mat-option>
                            <mat-option *ngFor="let configuration of configurationByTypesList" [value]="configuration.configurationId">{{configuration.configKey}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row m-t-10" *ngIf="configurationModel.configurationTypeCode == matrixConfigurationTypeCode">
                <div class="col-md-4 m-t-15 align-self-center">
                    <span class="form-label">Condition 5(Optional)</span>
                </div>
                <div class="col-md-8">
                    <mat-form-field>
                        <mat-select placeholder="Condition 5"
                                    [disabled]="configurationModel.addConfigurationMatrixModel.condition4 == null || configurationModel.addConfigurationMatrixModel.condition4.length <= 0"
                                    name="condition5" [(ngModel)]="configurationModel.addConfigurationMatrixModel.condition5">
                            <mat-option value=''>Select</mat-option>
                            <mat-option *ngFor="let configuration of configurationByTypesList" [value]="configuration.configurationId">{{configuration.configKey}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div class="row m-t-10" *ngIf="configurationModel.configurationTypeCode == matrixConfigurationTypeCode">
                <div class="col-md-4 align-self-center">
                    <span class="form-label">Value</span>
                </div>
                <div class="col-md-8">
                    <mat-checkbox name="hasValue" [(ngModel)]="configurationModel.addConfigurationMatrixModel.hasValue"></mat-checkbox>
                </div>
            </div>
        </div>
        <div mat-dialog-actions class="row">
            <div class="col-12">
                <div class="text-center pt-3 pb-4 d-flex  justify-content-center"> 
                    <button mat-raised-button color="primary" type="submit" class="oms-btn me-3">Save </button>&nbsp;&nbsp;
                    <button mat-raised-button color="primary" (click)="closeDialog()" type="button" class="oms-btn-primary">Cancel </button>
                </div>
            </div>
        </div>
    </form>
</div>

